import { RequiredTranslationsTemplate } from '.'

const lv: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Latvian',
  },
  home: {
    title: 'PRODUKTA ATSAUKUMS - ROCKRIDER XC500S',
    description:
      'Paldies, ka iegādājāties kalnu velosipēdu ROCKRIDER XC500S (MTB).Mēs esam identificējuši potenciālu priekšējās dakšas defektu. Tikai daži no pārdotajiem  velosipēdi ir bojāti. Lūdzu, ievadiet sava velosipēda izsekojamības numura 30 ciparus, lai pārbaudītu, vai šis atsaukums ietekmē Jūsu velosipēdu:',
    form: {
      title: 'Lūdzu, ievadiet sekojošo informāciju:',
      fields: {
        serialNumber: 'Velosipēda numurs',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Vārds',
        lastName: 'Uzvārds',
        email: 'E-pasta adrese',
        phone: 'Telefona nr.',
        country: 'Valsts',
        submit: 'Apstiprināt',
        choose: 'Pasirinkite...',
      },
      errors: {
        requiredField: 'Šis lauks ir obligāts',
        unknownSerialNumber: 'Nezināms sērijas numurs',
        provide6Numbers: 'Lūdzu, ņemiet vērā, ka ir nepieciešami 6 cipari.',
      },
      confirmations: {
        good: {
          title: 'Jūsu velosipēds netiek ietekmēts',
          p1: 'Lūdzu, ņemiet vērā, ka šis atsaukums neietekmē jūsu velosipēdu. Lūdzu, turpiniet baudīt braukšanu ar velosipēdu.',
          p2: 'Atvainojamies par sagādātajām neērtībām,',
          p3: 'Ar cieņu,',
          p4: 'Decathlon komanda',
        },
        defective: {
          title: 'Diemžēl, jūsu velosipēds ir ar defektu',
          p1: 'Mēs lūdzam jūs nekavējoties pārtraukt šī velosipēda lietošanu un sazināties ar tuvāko Decathlon veikalu, lai nomainītu dakšu.',
          p2: 'Lūdzu, ņemiet vērā, ka remonta laikā jūs, iespējams, nevarēsit izmantot velosipēdu vairākas dienas. Varat būt drošs, ka mēs darīsim visu iespējamo, lai samazinātu šīs kavēšanās. Mēs iesakām konsultēties tieši ar jūsu izvēlētā Decathlon veikala darbnīcu, lai uzzinātu remonta laiku.',
          p3: 'Informācija par tuvāko darbnīcu :',
          decathlonLocatorLink: 'https://decathlon.lv/lv/content/93-darbnica',
          p4: 'Zemāk jūs atradīsiet  “Atgriešanas paziņojumu”, kas jāiesniedz mūsu tehniķim, kad vērsīsieties darbnīcā:',
          p5: 'Lai iegūtu papildinformāciju, lūdzu, sazinieties ar mūsu īpašo kontaktu centru šī produkta atsaukšanai 0 805 38 38 49, bez maksas no Francijas ( pirmdienas līdz piektdienai no 9:00 līdz 19:00) vai pa e-pastu rappel.decathlon@fandi.fr',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Kā atrast velosipēda izsekojamības numuru',
      description:
        '30 ciparu skaitlis ir uzdrukāts uz jūsu velosipēda rāmja apakšpuses, netālu no apakšējā kronšteina un pedāļiem. Skatīt attēlu zemāk:',
    },
  },
}

export default lv
